<template>
    <div style="width: 1200px;  margin: 0 auto;">

        <Title :title="{name: '我的待办'}" :button-array="buttonArray" @openNewDealt="newdealtDraw"></Title>
        <el-card class="box-card">
            <el-row :gutter="20"  style="margin-left: 10px;">
                <el-col :span="5">
                    <el-input v-model="qparam.dealtTitle" placeholder="请输入标题" ></el-input>
                </el-col>
                <el-col :span="5">
                    <el-input v-model="qparam.remarks" placeholder="请输入内容"
                              style=" margin-left:30px;"></el-input>
                </el-col>
                <el-col :span="8">
                    <el-date-picker
                            style="width:250px;margin-left:30px;"
                            v-model="qparam.createTimeArr"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button icon="el-icon-refresh-left" type="primary" @click="reset">重置</el-button>

                    <el-button icon="el-icon-search"   type="primary" @click="selectListByData">查询</el-button>
                </el-col>
            </el-row>
        </el-card>

            <el-tabs type="border-card" style="min-height: 650px; margin-top: 10px;" @tab-click="changeType" >
                <el-tab-pane label="全部待办" >
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="totalCount == 0">无数据</div>
                    <el-card class="box-card" style="width: 45% ;float: left;margin: 10px;height: 330px;color: #606266;" shadow="hover" v-for="(item,index) in dealtAll" :key="index">
                        <div slot="header" class="clearfix">
                            <span>{{item.dealtTitle}}</span>
                            <el-popconfirm
                                    title="确定删除该待办吗？"
                                    @confirm="dealtDelete(item.id,item.dealtState)"
                                    v-if="item.dealtState == 2"
                            >
                                <el-button slot="reference"  style="float: right; padding: 8px; margin-left: 10px;" type="danger" icon="el-icon-delete" circle></el-button>
                            </el-popconfirm>
                            <el-popconfirm
                                    v-if="item.dealtState == 2"
                                    title="确定已完成该待办吗？"
                                    @confirm="dealtcomplete(item)"
                            >
                                <el-button  slot="reference"  style="float: right; padding: 8px; margin-left: 10px;" type="success" icon="el-icon-check" circle></el-button>
                            </el-popconfirm>
                            <div style="float: right;  margin-left: 10px; color: black;" v-if="item.dealtState == 1">
                                <el-tag type="success">已完成</el-tag>
                            </div>
                            <el-button @click="dealtEdit(item)" v-if="item.dealtState == 2"  style="float: right; padding: 8px; " type="primary" icon="el-icon-edit" circle></el-button>
                        </div>
                        <div style="display:flex;justify-content: space-between; ">
                            <span class="secondary"> 预计处理时间: </span>
                            <span > {{item.dealtStartTime}} - {{item.dealtEndTime}}</span>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 紧急程度: </span>
                            <el-rate v-model="item.urgencyType"  show-text :texts="['平常','一般','紧急','很紧急','特别紧急']" disabled=""></el-rate>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 待办详情: </span>
                        </div>
                        <div style="color: #909399;">
                            <p style="text-indent:24px">{{item.remarks}}</p>
                        </div>

                    </el-card>
                    <div class="block" style="margin-top: 20px;float: right;width: 100%; text-align: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="totalCount"
                                :page-size="qparam.size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current"
                        >
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已处理待办" >
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="totalCount == 0">无数据</div>
                    <el-card class="box-card" style="width: 45% ;float: left;margin: 10px;height: 330px;color: #606266;" shadow="hover" v-for="(item,index) in dealtAll" :key="index">
                        <div slot="header" class="clearfix">
                            <span>{{item.dealtTitle}}</span>
                        </div>
                        <div style="display:flex;justify-content: space-between; ">
                            <span class="secondary"> 预计处理时间: </span>
                            <span > {{item.dealtStartTime}} - {{item.dealtEndTime}}</span>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 紧急程度: </span>
                            <el-rate v-model="item.urgencyType"  show-text :texts="['平常','一般','紧急','很紧急','特别紧急']" disabled=""></el-rate>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 待办详情: </span>
                        </div>
                        <div style="color: #909399;">
                            <p style="text-indent:24px">{{item.remarks}}</p>
                        </div>
                    </el-card>
                    <div class="block" style="margin-top: 20px;float: right;width: 100%; text-align: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="totalCount"
                                :page-size="qparam.size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current"
                        >
                        </el-pagination>
                    </div>
                </el-tab-pane>

                <el-tab-pane label="未处理待办"  >
                    <div style="color:#909399; width:50px; margin:0 auto;" v-if="totalCount == 0">无数据</div>
                    <el-card class="box-card" style="width: 45% ;float: left;margin: 10px;height: 330px;color: #606266;" shadow="hover" v-for="(item,index) in dealtAll" :key="index">
                        <div slot="header" class="clearfix">
                            <span>{{item.dealtTitle}}</span>
                                <el-popconfirm
                                        title="确定删除该待办吗？"
                                        @confirm="dealtDelete(item.id,item.dealtState)"
                                >
                                <el-button slot="reference"  style="float: right; padding: 8px; margin-left: 10px;" type="danger" icon="el-icon-delete" circle></el-button>
                                </el-popconfirm>
                                <el-popconfirm
                                        title="确定已完成该待办吗？"
                                        @confirm="dealtcomplete(item)"
                                >
                                    <el-button  slot="reference"  style="float: right; padding: 8px; margin-left: 10px;" type="success" icon="el-icon-check" circle></el-button>
                                </el-popconfirm>

                                <el-button @click="dealtEdit(item)" style="float: right; padding: 8px; " type="primary" icon="el-icon-edit" circle></el-button>

                        </div>
                        <div style="display:flex;justify-content: space-between; ">
                            <span class="secondary"> 预计处理时间: </span>
                            <span > {{item.dealtStartTime}} - {{item.dealtEndTime}}</span>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 紧急程度: </span>
                            <el-rate v-model="item.urgencyType"  show-text :texts="['平常','一般','紧急','很紧急','特别紧急']" disabled=""></el-rate>
                        </div>
                        <div style="display:flex;justify-content: space-between; padding-top: 20px;">
                            <span class="secondary"> 待办详情: </span>
                        </div>
                        <div style="color: #909399;">
                            <p style="text-indent:24px">{{item.remarks}}</p>
                        </div>

                    </el-card>
                    <div class="block" style="margin-top: 20px;float: right;width: 100%; text-align: right">
                        <el-pagination
                                layout="prev, pager, next"
                                :total="totalCount"
                                :page-size="qparam.size"
                                @current-change="handleCurrentChange"
                                :current-page="qparam.current"
                        >
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
                <el-dialog
                        title="添加新待办"
                        :visible.sync="drawer"
                        :close-on-click-modal="false"
                        width="30%"
                >
                <el-form ref="form" :model="dealt" label-position="top" style="margin:0 10px;"  :rules="rules">
                    <el-form-item label="待办标题:" style="width:100%;" prop="dealtTitle">
                        <el-input v-model="dealt.dealtTitle" required="true"></el-input>
                    </el-form-item>
                    <el-form-item label="紧急程度:" style="width:100%;" prop="urgencyType">
                        <el-rate v-model="dealt.urgencyType" required="true" show-text :texts="['平常','一般','紧急','很紧急','特别紧急']" ></el-rate>
                    </el-form-item>

                    <el-form-item label="处理时间:" style="width:100%;" prop="time">
                        <el-date-picker
                                v-model="dealt.time"
                                style="width: 100%;"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期 "
                                value-format="yyyy-MM-dd HH:ss"
                                >
                        </el-date-picker>

                    </el-form-item>
                    <el-form-item label="待办内容:" prop="remarks">
                        <el-input type="textarea" v-model="dealt.remarks" :rows="6" style="width: 100%"></el-input>
                    </el-form-item>
                    <el-form-item style="margin: 50px auto 0 auto;">
                        <el-button type="primary" @click="newdealt()">
                            <span v-if="dealtEditState == 2">立即修改</span>
                            <span v-else>立即添加</span>
                        </el-button>
                        <el-button @click="drawer=false">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
    </div>
</template>

<script>
    import Title from "../../Title"
    import {requestDealtGrid,requestAddDealt,requestCompleteDealt,requestDeleteDealt} from "../../../api";
    export default {
        components: {Title},
        data() {
            return {
                dealtType:0, // 1 已读 2未读 0全部
                data: [],
                qparam:{
                    dealtTitle:'',
                    remarks:'',
                    createTimeArr:[],
                    current: 1,
                    size: 4,
                    type:0,
                },
                dealt: {
                    urgencyType: '',
                    dealtTitle: '',
                    remarks: '',
                    time: [],
                },
                rules: {
                    dealtTitle: [
                        {required: true, message: '请选择待办主题', trigger: 'change'},
                        { max: 40, message: '长度不能超过40个字符', trigger: ['change', 'blur']}
                    ],
                    remarks: [
                        { required: true, message: '请输入待办详情', trigger: 'change'},
                        { max: 200, message: "详情最多200个字符", trigger: 'change'}
                    ],
                    time: [
                        { required: true, message: '请选择处理时间', trigger: 'blur'}
                    ]
                },
                drawer: false, //编辑窗口的显示和隐藏
                dealtEditState:1,
                totalCount: 0,
                dealtAll: [],
                buttonArray:[{
                    type: 'success',
                    title: '添加待办',
                    method: 'openNewDealt',
                    disabled:false,
                }],
            }
        }, methods: {
            handleCurrentChange(val) {
                this.qparam.currentPage = val
                this.selectListByData();
            },
            newdealt(){
                this.$refs.form.validate(ispass =>{
                    if(ispass){
                        let param = JSON.parse(JSON.stringify(this.dealt));
                        param.dealtStartTime = this.dealt.time[0];
                        param.dealtEndTime = this.dealt.time[1];
                        param.time = "";
                        requestAddDealt(param).then(res => {
                            if(res.code == 200){
                                this.$message.success(res.msg)
                                this.drawer = false;
                                this.$refs.form.resetFields();
                                this.selectListByData();
                            }else{
                                this.$message.error(res.msg)
                            }
                        })

                    }
                })
            },
            async selectListByData(){
                let param = this.qparam;
                if(param.createTimeArr.length>0){
                    param.startTime = this.qparam.createTimeArr[0];
                    param.endTime = this.qparam.createTimeArr[1];
                    param.createTimeArr = null;
                }
                const res = await requestDealtGrid(param);
                if(res.code == 200){
                    this.dealtAll= res.rows;
                    this.totalCount = res.total;
                }else{
                    this.$message.error(res.msg);
                }

            },
            async dealtcomplete(item){
                const res = await requestCompleteDealt(item);
                if(res.code == 200){
                    this.$message.success(res.msg)
                    item.dealtState = 1;
                }else{
                    this.$message.error(res.msg);
                }
            },
            async dealtDelete(dealtId){
                const res = await requestDeleteDealt({"dealtId":dealtId});
                if(res.code == 200){
                    this.$message.success(res.msg)
                    this.selectListByData();
                }else{
                    this.$message.error(res.msg);
                }
            },
            dealtEdit(item){
                this.dealt = item;
                this.dealt.staffAccount =null;
                this.dealtEditState = 2;
                this.dealt.time= [item.dealtStartTime,item.dealtEndTime];
                this.drawer = true;
            },
            newdealtDraw(){
                this.dealtEditState = 1;
                this.dealt =  {
                    dealtTitle: '',
                    remarks: '',
                    time: [],
                };
                this.drawer = true;
            },
            changeType(type){
                this.qparam.type = type.index;
                this.selectListByData();
            },
            reset(){
                this.qparam.dealtTitle="";
                this.qparam.createTimeArr="";
                this.qparam.startTime = "";
                this.qparam.endTime = "",
                this.qparam.remarks="";
                this.selectListByData();
            }
        },created(){
            this.selectListByData();
        },
        name: "message"
    }
</script>

<style>

</style>
